import React, { Component } from 'react';
import propTypes from 'prop-types';
import { Utils, Select } from 'react-nice-inputs';
import { VacationContext } from 'js/components/step1/VacationContext';
import moment from 'moment';
import ut from 'js/modules/utils';
import daResorts from 'js/modules/resortData/index';


class MegaMenu extends Component {
  constructor(props) {
    super(props);
    // create a ref to store the thisInput DOM element
    this.thisInput = React.createRef();
    this.thisMask = React.createRef();
    this.thisOptions = React.createRef();
  }

  state = {
    classList: '',
    dataList: [],
    inputName: null,
    value: '',
    maskValue: '',
    brands: {
      s: 'Sandals',
      b: 'Beaches',
    },
    dropdownAutocompleteVisible: false,
    resorts: [],
    resortGateways: []
  }

  componentDidMount() {
    this.prepareClassList();
    this.prepareDataList();
    this.prepareForeignEvents();
    this.initMask();
    this.registerMouseDown();
    this.prepopulateInput();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.classList && this.props.classList) {
      if (prevProps.classList.length < this.props.classList.length || Utils.checkClassListNames(prevProps.classList, this.props.classList)) {
        this.prepareClassList();
      }
    }
    if (this.state.value !== '' && prevState.value !== this.state.value) {
      this.handleChange(this.thisInput);
    }
    if (prevProps.hasOwnProperty('value') && this.props.hasOwnProperty('value')) {
      if (prevProps.value !== this.props.value) {
        this.prepopulateInput();
      } else if (
        // yeah yeah this will be removed soon! let's see when will this be this removed, I added this 6/18/2020 in the middle of COVID19 plage
        prevProps.value === this.props.value &&
        !ut.compareObj(prevProps.fields, this.props.fields) &&
        !this._IsResortAvailable()) {
        this._ResetValue();
      }
    }
    if (prevProps.dataList.length < this.props.dataList.length) {
      this.prepareDataList();

      if (prevProps.hasOwnProperty('value') && this.props.hasOwnProperty('value')) {
        this.prepopulateInput();
      }
    }
  }

  componentWillUnmount() {
    this.unRegisterMouseDown();
  }

  prepopulateInput = () => {
    const { value } = { ... this.props };
    const option = this.findInDataList();

    if (value && option) {
      // this.thisMask.current.value = option.label;
      // this.thisInput.current.value = option.value;
      let maskValue = option.resortName;
      let finalValue = '';

      finalValue = value;
      if (!this._IsResortAvailable()) {
        finalValue = '';
        maskValue = '';
      }

      this.setState({ value: finalValue, maskValue });
    } else if (value === '') {

      this.setState({ value: '', maskValue: '' });
    }
  }

  findInDataList = () => {
    const { value, brand, dataList } = { ... this.props };
    const resortsPerBrand = [ ... dataList[brand] ];
    let res = null;

    if (value) {
      for (let i = 0; i < resortsPerBrand.length; i++) {
        const regionData = resortsPerBrand[i];

        for (let j = 0; j < regionData.resortList.length; j++) {
          const rstData = regionData.resortList[j];

          if (rstData.value === value) {
            res = rstData;
          }
        }
      }
    }

    return res;
  }

  registerMouseDown = () => {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('touchstart', this.handleClickOutside);
  };

  unRegisterMouseDown = () => {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('touchstart', this.handleClickOutside);
  };

  handleClickOutside = event => {
    const thisAutocompleteList = this.thisOptions.current;

    if (thisAutocompleteList) {
      if (this.thisMask && !this.thisMask.current.contains(event.target) && !thisAutocompleteList.contains(event.target)) {
        this.closeOptions();
      }
    }
  };

  resetOptions = () => {
    const dataListCopy = [ ...daResorts[this.props.brand] ];

    this.setState({ dataList: dataListCopy });
  }

  getBrandName = () => this.state.brands[this.props.brand];

  prepareClassList = () => {
    const { classList } = this.props;
    const classListString = Utils.createClassList(classList);

    this.setState({ classList: classListString });
  }

  prepareDataList = () => {
    const { dataList, brand } = this.props;

    this.setState({ dataList: dataList[brand] }, () => {
      this.buildResortList();
    });
  }

  prepareForeignEvents = () => {
    const body = document.getElementsByTagName('body')[0];

    body.onkeyup = e => {
      if (e.keyCode === 27 && this.state.inputName !== null) {
        const thisAutocompleteList = document.getElementById(`dropdown-autocomplete-${ this.state.inputName }`);

        if (thisAutocompleteList.classList.contains('visible')) {
          thisAutocompleteList.classList.remove('visible');
        }
      }
    };

    // TODO: key up and down
  }

  matches = (searchString) => {
    const dataListCopy = [ ...this.props.dataList ];
    const matches = dataListCopy.filter(item => item.label.toLowerCase().includes(searchString.toLowerCase()));

    this.setState({ dataList: matches });

    return matches;
  }

  toggleAction = () => {
    this.setState({ dropdownAutocompleteVisible: !this.state.dropdownAutocompleteVisible });
  }

  closeOptions = () => {
    this.setState({ dropdownAutocompleteVisible: false });
  }

  openOptions = () => {
    this.setState({ dropdownAutocompleteVisible: true });
  }

  toggleList = e => {
    const elem = e.currentTarget;
    const name = elem.name;

    this.setState({ inputName: name });

    this.toggleAction(name);
  }

  selectOption = e => {
    this.toggleAction(this.state.inputName);

    const maskValue = e.currentTarget.getAttribute('data-label');
    const value = e.currentTarget.getAttribute('data-value');
    const resortGateways = this.props.resortGateways;

    this.setState({ value, maskValue, resortGateways });
  }

  initMask = () => {
    this.thisMask.current.value = `Select ${ this.getBrandName() } Resort`;
  }

  isSelected = (wellIsIt, v) => {
    const { value } = this.state;
    let res = '';

    if (v === value) {
      const dataListCopy = [ ... this.state.dataList ];

      dataListCopy.map(regionData => {
        regionData.resortList.map(rst => {
          if (rst.value === value ) {
            res = 'selected accent-color';
          }
        });
      });
    }

    return res;
  }

  buildResortList = () => {
    const { dataList } = this.state;
    const resorts = [];
    const mobileResorts = [];

    dataList.map(region => {
      const { resortList } = region;

      resortList.map(rstData => {
        resorts.push(rstData);
        mobileResorts.push({ value: rstData.value, label: rstData.resortName });
      });
    });

    this.setState({ resorts, mobileResorts });
  }

  handleChange = e => {
    const name = this.thisInput.current.name;
    const value = this.state.value;
    const resortGateways = this.state.resortGateways;

    return this.props.onChange(value, name, resortGateways, e);
  }

  handleMobileChange = value => {
    const { mobileResorts } = this.state;
    const resortGateways = this.props.resortGateways;
    let maskValue = '';

    if (value !== '') {
      const selectedResort = mobileResorts.filter(r => r.value === value)[0];
      const { label } = selectedResort;

      maskValue = label;
    }

    this.setState({ value, maskValue, resortGateways });
  }

  resortAvailableByDates(rstCode, fields) {
    const { checkInDate: rawCheckInDate, checkOutDate: rawCheckOutDate } = fields;
    const mCheckInDate = moment(rawCheckInDate);
    const mCheckOutDate = moment(rawCheckOutDate);
    const resortDatesFM = window._app.results.resortDates;

    if (resortDatesFM) {
      if (Object.keys(resortDatesFM).length > 0) {
        const resortDates = resortDatesFM[rstCode.toLowerCase()];

        if (mCheckInDate.isValid() && mCheckOutDate.isValid() && resortDates) {
          let isAvailable = false;

          resortDates.forEach((resortDays) => {
            const rangeStart = moment(resortDays.starDate);
            const rangeEnd = moment(resortDays.endDate);
            const diffWithRangeStart = mCheckInDate.diff(rangeStart, 'days');
            const diffWithEndStart = mCheckInDate.diff(rangeEnd, 'days');

            if(diffWithEndStart < 0 || diffWithRangeStart < 0) {
              isAvailable = true;
            }
          });

          return isAvailable;
        }
      }
    }

    return false;
  }

  _ResetValue = () => {
    // console.log('this will set state');
    this.setState({value: '', maskValue: ''}, () => {
      this.handleChange(this.thisInput);
    });
  }

  _IsResortAvailable = () => {
    // &bypassform=1&startdate=2020-06-19&departuredate=2020-06-22&rst_code=src&noofadults=2
    const { checkInDate: rawCheckInDate, checkOutDate: rawCheckOutDate, rstCode } = this.props.fields;
    const mCheckInDate = moment(rawCheckInDate);
    const mCheckOutDate = moment(rawCheckOutDate);
    const resortDatesFM = window._app.results.resortDates;

    if (resortDatesFM) {
      if (Object.keys(resortDatesFM).length > 0) {
        const resortDates = resortDatesFM[rstCode.toLowerCase()];

        if (mCheckInDate.isValid() && mCheckOutDate.isValid() && resortDates) {
          let isAvailable = true;

          resortDates.forEach((resortDays) => {
            const rangeStart = moment(resortDays.starDate);
            const rangeEnd = moment(resortDays.endDate);
            const diffWithRangeStart = mCheckInDate.diff(rangeStart, 'days');
            const diffWithEndStart = mCheckInDate.diff(rangeEnd, 'days');

            if(diffWithEndStart < 0 || diffWithRangeStart < 0) {
              isAvailable = false;
            }
          });

          return isAvailable;
        }
      }
    }

    return true;
  }

  buildMobileResorts = (fields, reopeningDates = null) => {
    const mobileResorts = [];
    const { dataList } = this.state;

    dataList.map(region => {
      const { resortList } = region;

      resortList.map(rstData => {
        const resortDates = this.getResortDates(reopeningDates);
        const resortLabel = (this.resortAvailableByDates(rstData.value, fields) ? `${rstData.resortName} - Open ${moment(resortDates[rstData.resortName]).format('MMM DD, YYYY')}` : `${rstData.resortName}`);

        mobileResorts.push({ value: rstData.value, label: resortLabel, attrs: {disabled: this.resortAvailableByDates(rstData.value, fields)} });
      });
    });

    return mobileResorts;
  }

  getResortDates = (reopeningDates) => {
    const resortDates = {};

    if(reopeningDates) {
      reopeningDates.map((item) =>
        item.dates && item.dates.map((details) => {
          resortDates[details.resortName] = details.date;
        })
      );
    }

    return resortDates;
  }

  render() {
    const { attrs, name, brand, isRstCode } = this.props;
    const { classList, dropdownAutocompleteVisible, value, dataList } = this.state;

    return (
      <VacationContext.Consumer>
        {(context) => {

          const { reopeningDates = [] } = context.state;
          const resortDates = this.getResortDates(reopeningDates);

          return (
            <div className={ `mega-menu ${ brand } sm-12 md-6` }>
              <input ref={ this.thisInput } type="hidden" name={ name } id={ `hidden-autocomplete-${ name }` } value={ value } />
              <div className={ `${ classList } mask-wrap hide-mobile ${ isRstCode ? '' : 'is-invalid'}` }>
                {/* <input ref={ this.thisMask } type="text" name={ name } id={ name } className={`input ${ isRstCode ? '' : 'is-invalid'}`} onChange={ this.changeMask } onClick={ this.toggleList } value={ this.state.maskValue } { ...attrs } /> */}
                <div ref={ this.thisMask } name={ name } id={ name } className={`input ${ isRstCode ? '' : 'is-invalid'}`} onClick={ this.toggleList } value={ this.state.maskValue } { ...attrs }>{ (this.state.maskValue.length) ? this.state.maskValue : attrs.placeholder }</div>
              </div>
              <div className="sm-12 hide-desktop">
                <Select name={ name }
                  classList={ [ `${ isRstCode ? '' : 'is-invalid'}` ] }
                  options={ this.buildMobileResorts(context.state.fields, reopeningDates) }
                  onChange={ this.handleMobileChange }
                  defaultText={ attrs.placeholder }
                  value={ value }
                />
              </div>

              { !isRstCode && <p className="is-invalid rst-error">This field is required.</p> }

              { dropdownAutocompleteVisible &&
                <div className="autocomplete-list-wrap">
                  <ul ref={ this.thisOptions } className="autocomplete-list" id={ `dropdown-autocomplete-${ name }` }>
                    {
                      dataList.map((r, index) => (
                        <li key={ index }>
                          <span className="region-name">{ r.regionName }</span>
                          <ul>
                            {
                              r.resortList.map((rst, count) => {

                                // tontera para agregar los opening dates en la lista de mobile
                                const resortLabel = (this.resortAvailableByDates(rst.value, context.state.fields) ? `${rst.resortName} - Open ${moment(resortDates[rst.resortName]).format('MMM DD, YYYY')}` : `${rst.resortName}`);

                                return (
                                  <li className={ `resort-block ${ this.isSelected(rst.selected, rst.value) } ${ (this.resortAvailableByDates(rst.value, context.state.fields)) ? 'disabled' : '' }` }
                                    key={ rst.value }
                                    data-value={ rst.value }
                                    data-label={ resortLabel }
                                    data-count={ count }
                                    onClick={ this.selectOption }>
                                    <div className="resort-contents">
                                      <i className="check">&#10004;</i>
                                      <span>{ resortLabel }</span>
                                    </div>
                                  </li>
                                );
                              })
                            }
                          </ul>
                        </li>
                      ))
                    }
                  </ul>
                </div>
              }
            </div>
          );
        }}
      </VacationContext.Consumer>
    );
  }
}

MegaMenu.propTypes = {
  name: propTypes.string,
  classList: propTypes.array,
  attrs: propTypes.object,
  onChange: propTypes.func,
  dataList: propTypes.object,
  brand: propTypes.string,
  value: propTypes.string,
  fields: propTypes.object
};

MegaMenu.defaultProps = {
  dataList: daResorts,
  brand: 's',
  classList: ['sm-12'],
  fields: {
    rstCode: '',
    checkInDate: null,
    checkOutDate: null
  }
};

export default MegaMenu;



// WEBPACK FOOTER //
// ./js/components/step1/MegaMenu.js